// eslint-disable-next-line import/no-extraneous-dependencies
import '@lit-labs/ssr-client/lit-element-hydrate-support.js';
import * as braze from '@braze/web-sdk';

const brazePodlet = document.querySelector('braze-integration-podlet-content');
const { brazeConnDetails, loginId, useBraze } = JSON.parse(
    brazePodlet.getAttribute('initial-state'),
);
function renderContentCard(_card) {
    console.log('card: ', _card);

    const contentCardSection = brazePodlet.shadowRoot
        .querySelector('braze-podlet')
        .shadowRoot.querySelector('#content-card');

    contentCardSection.querySelector('#content-card-title').innerHTML =
        _card.title;
    contentCardSection.querySelector('#content-card-desc').innerHTML =
        _card.description;
    contentCardSection.querySelector('#content-card-img').src = _card.imageUrl;

    contentCardSection
        .querySelector('#content-card-link')
        .shadowRoot.querySelector('button')
        .setAttribute(
            'onclick',
            `window.location.href='${_card.extras.primaryButtonLink}'`,
        );

    contentCardSection.querySelector('#content-card-link').innerHTML =
        _card.extras.primaryButtonText;
}

if (useBraze) {
    braze.initialize(brazeConnDetails.brazeApiKey, {
        baseUrl: brazeConnDetails.brazeEndpointUrl,
        enableLogging: true,
    });
    braze.automaticallyShowInAppMessages();
    braze.changeUser(loginId);
    braze.subscribeToContentCardsUpdates((updates) => {
        const card = updates.cards[0];
        if (card) {
            renderContentCard(card);
        } else {
            brazePodlet.setAttribute('style', 'display:none');
        }
    });
    braze.requestContentCardsRefresh();
    braze.openSession();
}
